module.exports = __webpack_public_path__ + "v4assets/capacity-screenshot.aa9e24f2c07ea883822b16fa6010e0e0.png";